import React from 'react';
import { Navigate } from 'react-router-dom';
import { useCall } from '../customer-call-sdk';

interface WithCallConnectedProps {}

const withCallConnected = <P extends object>(Component: React.ComponentType<P>) => {
    const WithCallConnected: React.FC<P & WithCallConnectedProps> = ({ ...props }) => {
        const { connected } = useCall();
        if (connected) {
            return <Navigate to="/room" replace />;
        }
        return <Component {...(props as P)} />;
    };
    return WithCallConnected;
};

export default withCallConnected;
